/* global Sys, Core, Services */
Sys.ns("Core.Slots");

/**
 * The Free Rounds module.
 *
 * Handles the Free Rounds feature.
 *
 * @class Core.Slots.FreeRounds
 * @augments Core.Module
 */
Core.Slots.FreeRounds = {
    constructor: function() {
        Core.Slots.FreeRounds.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    getStateChanges: function() {
        var controller = this.controller;

        return {
            beforeLoaderClose: {
                queue: [
                    function(env) {
                        if (
                            Sys.utils.isFreeRoundsActive({ freeRoundsLeft: Services.freeRounds.getRemaining() }) &&
                            !controller.hasShownSplash
                        ) {
                            env.stateHandler.pushState(
                                env.states.setupFreeRounds
                            );
                        }
                    }
                ]
            },
            stopped: {
                queue: [
                    function(env) {
                        if (
                            Services.freeRounds.isActive() &&
                            Services.freeRounds.getRemaining() === 0 &&
                            Services.response.isNextActionSpin()
                        ) {
                            env.stateHandler.pushState(
                                env.states.checkForAdditionalFreeRounds
                            );
                        }
                    }
                ]
            },
            endFreeRounds: {
                state: {
                    name: "EndFreeRounds",
                    execute: function(env) {
                        if (Services.freeRounds.getRemaining() > 0) {
                            env.stateHandler.pushState(
                                env.states.setupFreeRounds
                            );
                        }
                    },
                    waitEvents: {
                        "notify:freeRounds.programEnded": false
                    }
                }
            },
            checkForAdditionalFreeRounds: {
                state: {
                    name: "CheckForAdditionalFreeRounds",
                    execute: function(env) {
                        env.stateHandler.pushState(
                            env.states.additionalFreeRounds
                        );
                    },
                    waitEvents: {
                        "notify:freeRounds.reInitResponseReceived": false
                    }
                }
            },
            additionalFreeRounds: {
                state: {
                    name: "AdditionalFreeRounds",
                    execute: function(env) {
                        switch (controller.nextFreeRoundsType) {
                            case controller.FREE_ROUNDS_TYPES.EXTRA: {
                                env.stateHandler.pushState(
                                    env.states.extraFreeRounds
                                );
                                break;
                            }

                            case controller.FREE_ROUNDS_TYPES.WIDGET:
                            case controller.FREE_ROUNDS_TYPES.NEW_PROGRAM: {
                                if (Services.freeRounds.isActive()) {
                                    env.stateHandler.pushState(
                                        env.states.setupFreeRounds
                                    );
                                    env.stateHandler.pushState(
                                        env.states.endFreeRounds
                                    );
                                }
                                break;
                            }

                            case controller.FREE_ROUNDS_TYPES.RELOAD:
                            case controller.FREE_ROUNDS_TYPES.NONE: {
                                if (Services.freeRounds.isActive()) {
                                    env.stateHandler.pushState(
                                        env.states.endFreeRounds
                                    );
                                }
                                break;
                            }

                            default: {
                                // do nothing
                                break;
                            }
                        }
                    },
                    waitEvents: {
                        "notify:freeRounds.additionalFreeRoundsProcessed": false
                    }
                }
            },
            extraFreeRounds: {
                state: {
                    name: "ExtraFreeRounds",
                    execute: function() {
                        // stub
                    },
                    waitEvents: {
                        "notify:freeRounds.dialogClosed": false
                    }
                }
            },
            setupFreeRounds: {
                state: {
                    name: "SetupFreeRounds",
                    execute: function() {
                        // stub
                    },
                    waitEvents: {
                        "notify:freeRounds.setupFinished": false
                    }
                }
            }
        };
    },

    /**
     * @protected
     * @inheritdoc
     */
    getDefaultMVCClasses: function() {
        return {
            controller: Core.Slots.FreeRoundsController
        };
    }
};

Core.Slots.FreeRounds = Sys.extend(
    Core.Module,
    Core.Slots.FreeRounds,
    "Core.Slots.FreeRounds"
);
